export const FAKE_MODULES_NAMES = {
  PAYMENTS: 'payments'
};